import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import FormMultiSelect, { SearchableSelect } from '../../_shared/forms/FormMultiSelect';
import DatePicker from 'react-datepicker/es';
import FormInputText from '../../_shared/forms/FormInputText';
import FormInputNumber from '../../_shared/forms/FormInputNumber';
import SubmitButton from '../../_shared/SubmitButton';
import JobExtras from '../JobExtras';
import { snakeCaseToTitle } from '../../../utils/Helpers';
import SkipHireService from '../../../services/SkipHireService';
import moment from 'moment';

export default class SkipHireForm extends Component {
    constructor(props) {
        super(props);

        let { job, skipHire } = this.props;

        this.state = {
            completion_date: job.completion_date ? moment(job.completion_date).toDate() : '',
            execution_date: job.execution_date ? moment(job.execution_date).toDate() : '',
            status: '',
            provider: '',
            team_member: '',
            teamMembersOptions: [],
            provider_price: skipHire.provider_price ? skipHire.provider_price / 100 : '',
            selectedSkipHireExtras: job.skip_hire_extras,
            showJobDetails: !job.waste_journey && job.status === 'completed',
            loading: false,
            errors: {},
        };
        console.log(this.props);
    }

    componentDidMount() {
        this.setJobStatus();
        this.setProvider();
        this.skipHireService = new SkipHireService();
    }

    setJobStatus = () => {
        if (this.props.job.waste_journey) {
            let waste_journey = this.props.statusesOptions.find((status) => {
                return status.name === 'Wasted journey';
            });
            this.setState({
                status: waste_journey,
            });
        } else if (this.props.job.status === 'completed') {
            let completed = this.props.statusesOptions.find((status) => {
                return status.name === 'Completed';
            });

            this.setState({
                status: completed,
            });
        }
    };

    removeFieldErrors = (field) => {
        let errors = { ...this.state.errors };
        delete errors[field];

        return errors;
    };

    changeStatus = (name, status) => {
        if (name === 'status') {
            this.setState({
                showJobDetails: status.value === 'completed',
            });
        }
    };

    setProvider = () => {
        if (typeof this.props.job.id === 'undefined' || !this.props.job.service_provider_id) {
            return;
        }

        let provider = this.props.providersOptions.find((provider) => {
            return provider.id === this.props.job.service_provider_id;
        });

        this.setState(
            {
                provider: provider,
                teamMembersOptions: provider.team_members,
            },
            () => this.setTeamMember()
        );
    };

    setTeamMembersOptions = () => {
        if (!this.state.provider || typeof this.state.provider === 'undefined') {
            return;
        }

        let provider = this.props.providersOptions.find((provider) => {
            return provider.id === this.state.provider.value;
        });

        if (typeof provider !== 'undefined') {
            this.setState({
                teamMembersOptions: provider.team_members,
            });
        }
    };

    setTeamMember = () => {
        if (typeof this.props.skipHire.id === 'undefined' || !this.props.skipHire.team_member_id) {
            return;
        }

        let team_member = this.state.teamMembersOptions.find((member) => {
            return member.id === this.props.skipHire.team_member_id;
        });

        this.setState({
            team_member: team_member,
        });
    };

    isWeekday = (date) => {
        let day = new Date(date).getDay();
        return day !== 0 && day !== 6;
    };

    handleChange = (e) => {
        const { name, value, target } = e.target;
        let errors = this.removeFieldErrors(name);

        this.setState({
            [name]: value,
            errors: errors,
        });
    };

    handleSelectChange = (e, name) => {
        let inputName = name;
        let errors = this.removeFieldErrors(inputName);

        this.changeStatus(inputName, e);

        this.setState(
            {
                [inputName]: e,
                errors: errors,
            },
            (oldState, newState, name = inputName) => {
                if (name === 'provider') {
                    this.setTeamMembersOptions();
                }
            }
        );
    };

    handleMultiSelectChange = (value, type) => {
        let extras = [];
        if (value && typeof value !== 'undefined' && value.length > 0) {
            extras = [...value];
        }
        this.setState({
            [type]: extras,
        });
    };

    handleDateChange = (date, name) => {
        let errors = this.removeFieldErrors(name);

        if (moment(date).isValid()) {
            this.setState({
                [name]: date,
                errors: errors,
            });
        } else {
            this.setState({ [name]: '' });
        }
    };

    handleExtraQtyChange = (e, extra, type) => {
        let extras = [...this.state[type]];

        let extraIndex = extras.findIndex((ex) => ex.value === extra.value);

        extras[extraIndex].quantity = e.target.value;

        this.setState({
            [type]: extras,
        });
    };

    validateForm = () => {
        let errors = {};
        let fields = ['status', 'execution_date', 'completion_date'];

        if (this.state.status && this.state.status.label === 'Completed') {
            fields.push('provider', 'team_member', 'provider_price');
        }

        fields.map((field) => {
            if (!this.state[field]) {
                errors[field] = `${snakeCaseToTitle(field)} field is required`;
            }
        });

        this.setState({ errors: errors });

        if (Object.keys(errors).length > 0) {
            toastr.error('Please fill in all required fields');
        }

        return Object.keys(errors).length === 0;
    };

    mapInputsToFormData = () => {
        let formData = new FormData();
        const mappable = ['execution_date', 'completion_date', 'provider_price'];

        let status = 'completed';
        let waste_journey = '0';
        if (this.state.status.value === 'waste_journey') {
            waste_journey = '1';
        }
        formData.append('status', status);
        formData.append('waste_journey', waste_journey);
        formData.append('provider', JSON.stringify(this.state.provider));
        formData.append('team_member', JSON.stringify(this.state.team_member));
        formData.append('skip_hire_extras', JSON.stringify(this.state.selectedSkipHireExtras));
        mappable.forEach((input) => {
            if (input === 'completion_date' || input === 'execution_date') {
                return formData.append(input, moment(this.state[input]).format('YYYY/MM/DD'));
            }
            return formData.append(input, this.state[input]);
        });

        return formData;
    };

    onSubmit = (e) => {
        e.preventDefault();

        if (this.validateForm()) {
            this.setState({ loading: true });

            const formData = this.mapInputsToFormData();

            if (typeof this.props.skipHire.id === 'undefined') {
                this.skipHireService
                    .store(this.props.url, formData)
                    .then((res) => {
                        this.setState({ loading: false });
                        toastr.success(res.data?.message ?? 'Skip hire created');
                        window.location.href = res.data.redirect_url;
                    })
                    .catch((err) => {
                        this.setState({ loading: false });
                        toastr.error('There was a problem while submitting the form, please try again later');
                    });
            } else {
                formData.append('_method', 'PATCH');
                this.skipHireService
                    .update(this.props.url, formData)
                    .then((res) => {
                        this.setState({ loading: false });
                        toastr.success(res.data?.message ?? 'Skip hire updated');
                        window.location.reload();
                    })
                    .catch((err) => {
                        this.setState({ loading: false });
                        toastr.error('There was a problem while submitting the form, please try again later');
                    });
            }
        }
    };

    render() {
        let { errors } = this.state;
        return (
            <form onSubmit={this.onSubmit}>
                <div className="row pb-3">
                    <div className="col-12">
                        <h6 className="py-2 pl-2 cw-bg-grey text-white">Job Details</h6>
                    </div>
                </div>

                <div className="row">
                    <div className="form-group col-md-4">
                        <SearchableSelect
                            classes={errors.status ? 'is-invalid' : ''}
                            name="status"
                            options={this.props.statusesOptions}
                            value={this.state.status}
                            handleChange={this.handleSelectChange}
                            label="status"
                            error={errors.status}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <label>Planned date</label>
                        <DatePicker
                            className={this.state.errors.execution_date ? 'form-control is-invalid' : 'form-control'}
                            placeholderText="Planned date..."
                            onChange={(date) => this.handleDateChange(date, 'execution_date')}
                            selected={this.state.execution_date}
                            dateFormat="dd/MM/yyyy"
                            filterDate={(date) => this.isWeekday(date)}
                        />
                        {this.state.errors.execution_date ? (
                            <div className="invalid-feedback" style={{ display: 'block' }}>
                                {this.state.errors.execution_date}
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                    <div className="form-group col-md-4">
                        <label>Completion date</label>
                        <DatePicker
                            className={this.state.errors.completion_date ? 'form-control is-invalid' : 'form-control'}
                            placeholderText="Completion date..."
                            onChange={(date) => this.handleDateChange(date, 'completion_date')}
                            selected={this.state.completion_date}
                            dateFormat="dd/MM/yyyy"
                            filterDate={(date) => this.isWeekday(date)}
                        />
                        {this.state.errors.completion_date ? (
                            <div className="invalid-feedback" style={{ display: 'block' }}>
                                {this.state.errors.completion_date}
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                </div>

                {this.state.showJobDetails ? (
                    <div className="row">
                        <div className="form-group col-md-4">
                            <SearchableSelect
                                classes={errors.provider ? 'is-invalid' : ''}
                                name="provider"
                                options={this.props.providersOptions}
                                value={this.state.provider}
                                handleChange={this.handleSelectChange}
                                label="Provider"
                                error={errors.provider}
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <SearchableSelect
                                classes={errors.team_member ? 'is-invalid' : ''}
                                name="team_member"
                                options={this.state.teamMembersOptions}
                                value={this.state.team_member}
                                handleChange={this.handleSelectChange}
                                label="Team member"
                                error={errors.team_member}
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <FormInputNumber
                                type="number"
                                label="Provider price"
                                name="provider_price"
                                step="0.01"
                                min="1"
                                classes={errors.provider_price ? 'form-control is-invalid' : 'form-control'}
                                value={this.state.provider_price}
                                handleChange={this.handleChange}
                                error={errors.provider_price}
                            />
                        </div>

                        <div className="form-group col-md-4 ml-2">
                            <FormMultiSelect
                                label="Skip hire extras"
                                options={this.props.skipHireExtras}
                                handleMultiSelectChange={(value) =>
                                    this.handleMultiSelectChange(value, 'selectedSkipHireExtras')
                                }
                                classes="form-control"
                                prefixes={this.state.selectedSkipHireExtras}
                            />
                        </div>
                    </div>
                ) : (
                    ''
                )}

                {this.state.showJobDetails ? (
                    <JobExtras
                        type="Skip hire extra"
                        extras={this.state.selectedSkipHireExtras}
                        onExtraQtyChange={this.handleExtraQtyChange}
                        extrasType="selectedSkipHireExtras"
                        dtn={false}
                    />
                ) : (
                    ''
                )}
                <div className="row">
                    <div className="col-12">
                        <SubmitButton buttonText="Save" loading={this.state.loading} />
                    </div>
                </div>
            </form>
        );
    }
}

if (document.getElementById('skip-hire-form')) {
    const element = document.getElementById('skip-hire-form');
    ReactDOM.render(
        <SkipHireForm
            job={JSON.parse(element.dataset.job)}
            skipHire={JSON.parse(element.dataset.skip_hire)}
            skipHireExtras={JSON.parse(element.dataset.skip_hire_extras)}
            providersOptions={JSON.parse(element.dataset.providers)}
            statusesOptions={JSON.parse(element.dataset.statuses)}
            url={element.dataset.url}
        />,
        element
    );
}
